import { useIncidentBanner } from "../lib/incidentBanner";
import Callout from "./Callout";

const IncidentBanner = () => {
  const banner = useIncidentBanner();

  if (!banner) {
    return null;
  }

  return (
    <div className="mx-4 mt-4 shrink-0 sm:mx-6">
      <Callout type={banner.severity} message={banner.message} centerIcon />
    </div>
  );
};

export default IncidentBanner;
